import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { FetchWindowsGruoupsResponse } from "./FetchWindowsGroupsResponse";

const ENDPOINT = "/usermanagement/windows_groups";

export class FetchWindowsGroupsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<FetchWindowsGruoupsResponse> {
        var res = await this.executeCommand();
        return new FetchWindowsGruoupsResponse(res);
    }
}
